import {t} from 'i18next'
import { FormGroup, Label, Input } from 'reactstrap'

import { isNull } from '../../izUtils'

const TechStandby = ({techStandby, handleStandbyChange}) => {
    if (!isNull(techStandby) && techStandby.length !== 0) {
        return (
            <>
                <hr/>
                <h6 className="mb-3">{t('schedule.exception.standby.title')}</h6>
                {techStandby.map(tech => (
                    <FormGroup key={'tech-'+tech.id}>
                        <Label>{t('schedule.exception.standby.technician')} {tech.title}</Label>
                        <Input
                            type="select"
                            onChange={(event) => handleStandbyChange(event, tech.id)}
                        >
                            <option key="default-option" value={""} style={{ fontWeight: '600' }}>{t('defaultSelect')}</option>
                            {tech.standby.map(standby => (
                                <option key={'tech-'+tech.id+'-standby-'+standby.id} value={standby.id}>{standby.title}</option>
                            ))}
                        </Input>
                    </FormGroup>
                ))}
            </>
        )
    }
}

export default TechStandby